// Obtenemos el customer
const host_parts = window.location.host.split(".");
const customer = host_parts[0];

var params = {};
if (customer === "localhost:8080") {
  params = require("./customers/default/params.js");
} else {
  try {
    // Buscamos si existe la carpeta con la configuración para el customer
    params = require("./customers/" + customer + "/params.js");
  } catch (e) {
    // Si no existe, definimos las rutas usando el customer
    const curr_domain = host_parts.length > 1 ? host_parts[1] : "";
    const domain = curr_domain === "veetal" ? "veetal.app" : "hawgbi.com";
    params = {
      default: {
        auth_url: "https://" + customer + "-api." + domain + "/auth",
        api_url: "https://" + customer + "-api." + domain + "/api",
        // Configuración por defecto para Google Analytics
        analytics: {
          gaId: null // ID por defecto
        }
      }
    };
  }
}

// Slug del customer. Se usa, entre otras cosas, para resolver las capturas de
// pantalla propias de cada cliente en la pantalla de novedades.
//
// Lo deducimos de la api_url y no del host de la página, porque en local
// (localhost:8080) el host no dice a qué cliente estamos apuntando pero la
// api_url sí:
//   https://axel-api.veetal.app/api  -> axel
//   http://axel.dev.hawgbi.com/api   -> axel
const customer_slug = (function() {
  try {
    const host = params.default.api_url.split("//")[1].split("/")[0];
    return host.split(".")[0].replace(/-api$/, "");
  } catch (e) {
    return customer;
  }
})();

export { customer_slug as customer };

export default {
  auth_url: params.default.auth_url,
  api_url: params.default.api_url,
  analytics: params.default.analytics || { gaId: null },
  customer: customer_slug
};
